.collapsed-fields__container {
  width: 100%;
  border-radius: 0;

  & .ant-collapse-content-box {
    padding: 16px !important;
  }

  & .ant-collapse-header {
    align-items: center;
    line-height: 28px;
  }

  & .ant-collapse-header .ant-collapse-expand-icon {
    height: 28px !important;
  }

  & .ant-collapse-item-active>.ant-collapse-header {
    background-color: var(--color-main-1);
  }

  &>.ant-collapse-item:last-child,
  &>.ant-collapse-item:last-child>.ant-collapse-header {
    border-radius: 0;
  }

  & .ant-collapse-header-text {
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
  }

  & .ant-collapse-arrow {
    font-size: 18px !important;
  }
}

.collapsed-fields__container .collapsed-fields__panel {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;

  gap: 48px;
}

.collapsed-fields__container .collapsed-fields__panel-footer {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

.collapsed-fields__panel-footer .collapsed-fields__panel-footer__next-button {
  display: flex;
  flex-flow: row-reverse nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 8px;

  & .ant-btn-icon {
    margin-inline-end: 0 !important;
  }
}